import { Column } from '@tanstack/react-table';

export const createHandleColumnFilterChange = <T>(column: Column<unknown>) => {
  const handleColumnFilterChange = (groups: T[]) => {
    if (!column) {
      return;
    }

    if (groups.length === 0) {
      column.setFilterValue(null);
    } else {
      column.setFilterValue({
        value: groups,
        filterType: column.columnDef.filterType,
      });
    }
  };
  return handleColumnFilterChange;
};
